import _ from 'lodash';
import {AllowedLocale} from '../redux/localeActionTypes';

export const isAllowedLocale = (locale: string): locale is AllowedLocale => {
  const allowedLocales: AllowedLocale[] = ['en', 'he'];
  return _.includes(allowedLocales, locale);
};

export const localeDirection = (locale: AllowedLocale) => {
  return (locale === 'he') ? 'rtl' : 'ltr';
};
